var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"MenuItem",attrs:{"to":_vm.url},nativeOn:{"click":function($event){return _vm.clickAction.apply(null, arguments)}}},[_c('span',{staticClass:"MenuItem-text text-heading text-heading--3 p-20"},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('icon',{attrs:{"name":"underline"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }